<div class="d-flex justify-content-between align-items-center">
    <h2 mat-dialog-title class="margin-0">Template Name - {{title}}</h2>
    <div class="d-flex justify-content-end align-items-center">
        <div style="margin: 10px;">
            <button mat-raised-button actions class="button-container primary" style="color: #fff;">
                USE TEMPLATE
            </button>
        </div>
        <button mat-icon-button class="template_btn" mat-dialog-close aria-label="Example icon-button with heart icon">
            <mat-icon class="close-icon" mat-dialog-close>
                close
            </mat-icon>
        </button>
    </div>
</div>
<mat-divider class="mat-divider"></mat-divider>

<mat-dialog-content class="mat-typography dialog-without-actions" style="overflow-x:hidden">

    <div class="sub-header-container">
        <div class="left-sub-header-container d-flex">

            <h3 class="dlog-date-container body-font-size" style="margin-top: 5px;">
                {{showDate}}
            </h3>
        </div>
        <div class="right-sub-header-container">

        </div>
    </div>
    <div>
        <ul class="un-order-list-container" style="margin-bottom: 10px;">
            <div class="accordion-item-container" id="displayAttendeeSec">

                <ng-container *ngFor="let attendeeName of data">
                    <app-participant-view-chip [participantName]="attendeeName"></app-participant-view-chip>
                </ng-container>
            </div>
        </ul>
    </div>
    <mat-divider></mat-divider>
    <div class="task-details">
        <cdk-accordion class="example-accordion" multi="true">
            <cdk-accordion-item expanded="true" #accordionItem="cdkAccordionItem"
                class="example-accordion-item overallagenda_div" tabindex="0">
                <div class="d-flex">

                    <div class="d-flex col-md-11">

                        <mat-icon>keyboard_arrow_down</mat-icon>

                        <div>
                            <h3 class="body-font-size f-weight agendaTitle">Title of the Agenda</h3>
                        </div>
                    </div>

                </div>
                <div class="" role="region" [style.display]="accordionItem.expanded ? '' : 'none'">

                    <div style="margin-top: 5px;margin-bottom: 0px;">
                        <mat-list>
                            <mat-list-item class="height-0" style="margin-top: 5px;">
                                <div class="d-flex" style="width: 100%;">

                                    <div class="d-flex col-md-11">
                                        <div>
                                            <button class="global-icn-bttn-containers mat-margin-3px" mat-mini-fab
                                                tooltip="Notes" triggers="hover">
                                                <mat-icon class="global-icn-size notes">notes</mat-icon>
                                            </button>
                                        </div>
                                        <div>
                                            <h4 class="acc-content body-font-size" style="margin-top: 7px;">Lorem Ipsum
                                                is simply dummy text of the printing and typesetting industry. Lorem
                                                Ipsum has been the industry's standard dummy text ever since the 1500s,
                                                when an unknown printer took a galley of type and scrambled it to make a
                                                type specimen book</h4>
                                        </div>
                                    </div>
                                </div>
                            </mat-list-item>
                            <mat-list-item class="height-0" style="margin-top: 5px;">
                                <div class="d-flex" style="width: 100%">

                                    <div class="d-flex col-md-11">
                                        <div>
                                            <button class="mat-margin-3px global-icn-bttn-containers" mat-mini-fab
                                                tooltip="Task" triggers="hover">
                                                <mat-icon class="global-icn-size assignment">assignment</mat-icon>
                                            </button>
                                        </div>
                                        <div>
                                            <h4 class="acc-content body-font-size" style="margin-top: 7px;">Lorem Ipsum
                                                is simply dummy text of the printing and typesetting industry assigned
                                                by Admin &#64; {{showDate}}</h4>
                                        </div>
                                    </div>

                                </div>
                            </mat-list-item>
                            <mat-list-item class="height-0">
                                <div class="d-flex" style="width: 100%;">

                                    <div class="d-flex col-md-11">
                                        <div>
                                            <button class="mat-margin-3px global-icn-bttn-containers hide" mat-mini-fab
                                                tooltip="Decision" triggers="hover">
                                                <mat-icon class="global-icn-size decision">thumb_up</mat-icon>
                                            </button>
                                        </div>
                                        <div>
                                            <h4 class="acc-content body-font-size" style="margin-top: 7px;">Lorem Ipsum
                                                is simply dummy text of the printing and typesetting industry. Lorem
                                                Ipsum has been the industry's standard dummy text.</h4>
                                        </div>
                                    </div>


                                </div>
                            </mat-list-item>
                                               </mat-list>
                    </div>
                    <div>
                        <h3 class="margin-0 body-font-size" style="margin-left: 45px !important;"></h3>
                    </div>

                </div>
            </cdk-accordion-item>
        </cdk-accordion>
    </div>
    <div class="task-details">
        <cdk-accordion class="example-accordion" multi="true">
            <cdk-accordion-item expanded="true" #accordionItem="cdkAccordionItem"
                class="example-accordion-item overallagenda_div" tabindex="0">
                <div class="d-flex">

                    <div class="d-flex col-md-11">

                        <mat-icon>keyboard_arrow_down</mat-icon>

                        <div>
                            <h3 class="margin-0 body-font-size f-weight agendaTitle">Title of the Agenda One</h3>
                        </div>
                    </div>

                </div>
                <div class="" role="region" [style.display]="accordionItem.expanded ? '' : 'none'">

                    <div style="margin-top: 5px;margin-bottom: 5px;">
                        <mat-list>
                            <mat-list-item class="height-0" style="margin-top: 10px;">
                                <div class="d-flex" style="width: 100%;">

                                    <div class="d-flex col-md-11">
                                        <div>
                                            <button class="global-icn-bttn-containers mat-margin-3px" mat-mini-fab
                                                tooltip="Notes" triggers="hover">
                                                <mat-icon class="global-icn-size notes">notes</mat-icon>
                                            </button>
                                        </div>
                                        <div>
                                            <h4 class="acc-content body-font-size" style="margin-top: 7px;">Lorem Ipsum
                                                is simply dummy text of the printing and typesetting industry. Lorem
                                                Ipsum has been the industry's standard dummy text ever since the 1500s,
                                                when an unknown printer took a galley of type and scrambled it to make a
                                                type specimen book</h4>
                                        </div>
                                    </div>
                                </div>
                            </mat-list-item>
                            <mat-list-item class="height-0" style="margin-top: 10px;">
                                <div class="d-flex" style="width: 100%;">

                                    <div class="d-flex col-md-11">
                                        <div>
                                            <button class="mat-margin-3px global-icn-bttn-containers" mat-mini-fab
                                                tooltip="Task" triggers="hover">
                                                <mat-icon class="global-icn-size assignment">assignment</mat-icon>
                                            </button>
                                        </div>
                                        <div>
                                            <h4 class="acc-content body-font-size" style="margin-top: 7px;">Lorem Ipsum
                                                is simply dummy text of the printing and typesetting industry assigned
                                                by Admin &#64; {{showDate}}</h4>
                                        </div>
                                    </div>

                                </div>
                            </mat-list-item>
                            <mat-list-item class="height-0">
                                <div class="d-flex" style="width: 100%;">

                                    <div class="d-flex col-md-11">
                                        <div>
                                            <button class="mat-margin-3px global-icn-bttn-containers hide" mat-mini-fab
                                                tooltip="Decision" triggers="hover">
                                                <mat-icon class="global-icn-size decision">thumb_up</mat-icon>
                                            </button>
                                        </div>
                                        <div>
                                            <h4 class="acc-content body-font-size" style="margin-top: 7px;">Lorem Ipsum
                                                is simply dummy text of the printing and typesetting industry. Lorem
                                                Ipsum has been the industry's standard dummy text.</h4>
                                        </div>
                                    </div>

                                </div>
                            </mat-list-item>

                        </mat-list>
                    </div>
                    <div>
                        <h3 class="margin-0 body-font-size" style="margin-left: 45px !important;"></h3>
                    </div>

                </div>
</cdk-accordion-item>
</cdk-accordion>
    </div>



</mat-dialog-content>